import { appConfig } from "src/config";
import {
  COMPOUNDED_MEDICATION_PRODUCT_NAMES,
  MEDICATION_PRODUCT_NAMES,
  MedProductName,
} from "src/utils/medProductNames";
import getStore, { CoreReduxState } from "src/utils/redux/store";

export function isMedicationProductName(
  productName?: string
): productName is MedProductName {
  return (
    productName != null &&
    (MEDICATION_PRODUCT_NAMES as readonly string[]).includes(productName)
  );
}

// Also exposed as a pageset segment via src/utils/userSegment/index.ts.
export function isMedicationCancelFlowEnabled() {
  // Worker-controlled GrowConfig kill switch with no URL override, so the flow
  // can't be reached in production before it is turned on.
  return appConfig.MEDICATION_CANCEL_FLOW_ENABLED;
}

// Also exposed as a pageset segment via src/utils/userSegment/index.ts.
export function isSubscriptionMedication(
  state: CoreReduxState = getStore().getState()
) {
  // Gated on the kill switch too, so shared counter-offer pages don't render
  // medication variants before the flow is turned on.
  return (
    isMedicationCancelFlowEnabled() &&
    isMedicationProductName(state.serverContext.product_name)
  );
}

export type MedicationType = "branded" | "compounded";

export function getMedicationTypeFromContext(
  state: CoreReduxState = getStore().getState()
): MedicationType | undefined {
  const productName = state.serverContext.product_name;
  if (
    !isSubscriptionMedication(state) ||
    !isMedicationProductName(productName)
  ) {
    return undefined;
  }
  // Branded by exclusion, so a new branded product only needs adding to medProductNames.
  return COMPOUNDED_MEDICATION_PRODUCT_NAMES.has(productName)
    ? "compounded"
    : "branded";
}
